module.exports = __webpack_public_path__ + "static/media/Pinetree - Notice of Proposal to Revoke a Licence.207cef21.pdf";